import ApiServer from "../ApiServer.js";
import * as amplify from "../util/amplify.ts";
import * as i18n from "../i18n.ts";
import * as modal from "../util/modal.ts";
import * as FwDatas from "../FwDatas.ts";
import * as Html from "../util/Html.ts";
import {familyPickOther} from "../modal/familypicker.js";
import {EventStore} from "../server/EventStore.js";
import { checkEventLimitOntry, modalEventHardLimitReached, modalOtherCircleEventHardLimitReached } from "./calendarclean.js";
import "../util/MemberOrder.ts"

  var
    currentUpdateCall;

  function updateErrorHandler(err){
    if(err.FiZClassId==="23"){
      modal.alert("event.FizApiDistinctOccurenceIntersectException");   
    }else{
      modal.alert("event.updateError");
    }
  }
  
  ApiServer["custom.evtupdate"] = function(form,success){
    function doit(option){
      modal.closeModal()
      ApiServer.evtupdate.prepare(option)(form,success,updateErrorHandler)
    }
    ApiServer.evtupdateoption(form,function(options){
      if(options.length<2){
        doit(options[0])
      }else{
        modal.ask({
          title:'event.updaterecurringtitle',
          message:'event.updaterecurringtext',
          button:options.map(opt=>{return {value:opt,title:'event.updaterecurring'+opt}})
        },function(opt){
          if(opt) doit(opt)
        });
      }
    });
  };
  ApiServer["custom.evtcreate"] = ApiServer.evtcreate.prepare(function(){
    amplify.publish('eventCreated')
    EventStore.invalidate(metaId=>metaId.startsWith('calendar/'))
  });
  
  ApiServer["custom.evtcreateotherscope"] = async function(form){
    let 
      familyId = form.scope.value,
      familyName = FwDatas.getFamily(familyId).name,
      TPL = await import("../modal/snack.mustache")
    try{
      await ApiServer.evtcreate.prepare(function(){
        amplify.publish('eventCreated')
        EventStore.invalidate(metaId=>metaId.startsWith('calendar/'));
        modal.snack(TPL, { html: i18n.get('event.createdothercircle','<u data-fw-onclick="changetofamily|'+familyId+'">'+Html.escape(familyName)+'</u>') },6000)
      })(form);
    }catch(e){

    }
    
    
  }
  export function editEventOption(option){
    currentUpdateCall({option:option});
  }
  
  function initEditModal(){
    $("select[name='attendee.$i.accountId']").on('change',function(){
      var 
        select = $(this),
        form = select.parents('form').get(0),
        amIAttendee;
      try{
        amIAttendee = select.val().indexOf(""+FwDatas.getAccountId())>-1;
      }catch(e){
        //ie8 here too bad
        amIAttendee = false;
      }  
      $(form).find(':input[name="reminder"]').prop('disabled',!amIAttendee).nextAll('select').prop('disabled',!amIAttendee);
      
    }).trigger('change');
  }

/*
  Function: createEvent()
  Open the modal window to create a new event
*/
export async function createEvent(startDate,endDate,allDay,calendar, resource){
  
  var [
    EVENT_EDIT_TEMPLATE,
    TIMETABLEEVENT_EDIT_TEMPLATE,
    doOpen
  ] = await Promise.all([
      import("../modal/event_edit.mustache"),
      import("../timetable/timetableevent_edit.mustache"),
      calendar===undefined?checkEventLimitOntry():true //we do not check for timetable
    ]);
    
  if(doOpen){
    if(!endDate){
      endDate = new Date(startDate+30*60000);
    }
    
    var 
      settings = FwDatas.getSettingsPerFamily();
    
    
    modal.openModal(calendar && calendar.timetable && !calendar.timetable.isOneTime?TIMETABLEEVENT_EDIT_TEMPLATE:EVENT_EDIT_TEMPLATE,{
      toAll:resource===undefined,
      attendees:resource===undefined?undefined:[{accountId:resource.id}],
      allDay:!!allDay,
      calendar:calendar,
      start:startDate,
      end:endDate,
      reminder0:{simple:settings.defaultReminderType==='NONE'?"":(allDay?"MINUTE-0":settings.defaultReminderUnit+"-"+settings.defaultReminderValue)},
      recurrencyDescriptor:new ApiServer.types.RecurrencyDescriptor({recurrency:'NONE'})
      
    });
    initEditModal();
  }else{
    modalEventHardLimitReached()
  }
}

  /*
    Function: editEvent(event)
    Open a modal window to edit given event

    Parameter:
      event - object, event data
  */
  export function editEvent(event){
    import("../modal/event_edit.mustache").then(EVENT_EDIT_TEMPLATE=>{
      import("../timetable/timetableevent_edit.mustache").then(TIMETABLEEVENT_EDIT_TEMPLATE=>{
        modal.closeModal();
        modal.openModal(
          event.calendar && event.calendar.timetable && !event.calendar.timetable.isOneTime?TIMETABLEEVENT_EDIT_TEMPLATE:EVENT_EDIT_TEMPLATE,
          event
        );
        initEditModal();
      });
    })
  }
  
  /*
    Function: viewEventDetails(event)
    Open a modal window to display the details of given event

    Parameter:
      event - object, event data
  */
  export function viewEventDetails(event,isDisplayInTimetable){
    event.buildDisplayInCalendar();
    event.isDisplayInTimetable = isDisplayInTimetable;
    import("../modal/event_view.mustache").then(function(EVENT_DETAILS_TEMPLATE){
      modal.closeModal();
      modal.openModal(
        EVENT_DETAILS_TEMPLATE,
        event
      );
    });
  }
  amplify.subscribe("eventCreated eventUpdated eventDeleted contactUpdated",function(){
    modal.closeModal();
  });

Html.register({
  calediterror(metaId){
    var calendar = FwDatas.get(metaId);
    if(calendar.mine){
      var isOutlook = metaId.indexOf("extCalendarOutlook")===0;
      
      modal.ask({
        title:"calendars.calerror.modaltitle",
        lottie:"/images/lottie/robot.json",
        message:calendar.errorMessage,
        copyable:i18n.get("calendars.calerror.errorcode",calendar.errorCode),
        button:[
          {title:'actions.reconnect',action:isOutlook?"outlookconnect":"googleconnect"}
        ]
      })
    }else{
      modal.ask({
        title:"calendars.calerror.modaltitle",
        lottie:"/images/lottie/robot.json",
        message:calendar.errorMessage,
        button:[
          {title:'actions.gotit'}
        ]
      })
    }
  },
  caledit(metaId){
    import("../modal/cal_edit.mustache").then(function(TPL){
      var calendar = FwDatas.get(metaId);
      if(metaId.indexOf('calendarMealPlanner')===0){
        ApiServer.mpsettingsget(function(mpSettings){
          calendar.mpSettings = mpSettings;
        })
      }
      if(calendar.icalAble){
        calendar.icalui = true;
        ApiServer.evticalvisibleurl(false,metaId,function(url){
          calendar.icalurl = url;
        })
      }
      
      ApiServer.aftergroup(function(){
        modal.openModal(TPL,calendar);
      })
      
    });
  },
  evtclick(id){
    if(id.indexOf('task')===0){
      Html.trigger($(this),"taskview",[id])
    }else{
      var evtFw = FwDatas.get(id);
      if(evtFw){
        viewEventDetails(evtFw)
      }else{
        ApiServer.evtget(id,viewEventDetails);
      }
    }
    

  },
  async eventcopy(){
    let 
      eventId = this.metaId(),
      picked = await familyPickOther(i18n.get('actions.copytopicker'));
    
    if(picked){
      if(!await checkEventLimitOntry(picked.metaId)){
        modalOtherCircleEventHardLimitReached()
        return;
      }

      var copy = new ApiServer.types.IEvent(Object.assign(FwDatas.get(eventId).json,{metaId:null}));
      copy.scope = picked.metaId;
      copy.calendarId = null;
      copy.toAll = true;
      
      editEvent(copy)
    }  
      
  },
  timetabledelete(metaId){
    if(!metaId) metaId = this.metaId();
    var timetable = FwDatas.get(metaId)
    modal.ask({
      title:i18n.get("timetable.deletetitle",timetable.name),
      message:'timetable.confirmdelete',
      button:[
        {title:"actions.delete",class:"negative",onclick:doTheDelete},
        {title:"actions.cancel",class:"secondary",onclick:modal.closeModal}
      ]
    });
    function doTheDelete(){
      ApiServer.metadelete(metaId);
      amplify.publish("timetableUpdated")
    }
    
  },
  caledu(type){
    if(type==='private'){
      modal.ask({
        title:"new_event.private",
        lottie:"/images/lottie/face_with_monocle.json",
        message:"new_event.privateexplain",
        button:[{title:'actions.gotit'}]
      })
    }else if(type==='timezonelocal'){
      modal.ask({
        title:"timezone.localtime",
        lottie:"/images/lottie/anim_clock.json",
        message:"timezone.localedu",
        button:[{title:'actions.gotit'}]
      })
    }else if(type==='timezone'){
      modal.ask({
        title:"timezone.target",
        lottie:"/images/lottie/anim_clock.json",
        message:"timezone.targetedu",
        button:[{title:'actions.gotit'}]
      })
    }else{
      throw new Error('Invalid type for caledu|'+type)
    }
  }
})

export function askCalendarUrl(options){
  return modal.askUrl(Object.assign({},{
    image:"/images/calendar_dialog_subscription_add.svg",
    message:'calendars.calbyurl.text',
    placeholder:'calendars.calbyurl.placeholder',
    sub:'calendars.calbyurl.subtext',
    buttonName:'calendars.calbyurl.button',
    validate:async function(url){
      try{
        return await ApiServer.evtcalcheckurl(url)
      }catch(error){
        let errorKey = {"405":"calendars.calbyurl.error405","406":"calendars.calbyurl.error406"}[error.code]||"calendars.calbyurl.errortext"; 
        modal.oops(errorKey);
        return false;
      }
    }
  },options))
}